module.exports = __webpack_public_path__ + "media/kot.d8d435aa.mp3";